/* VENOR grid — quick add.
 *
 * Every skate needs one of four sizes, so there is no honest one-tap add. The
 * button opens the sizes on the card instead, and each size hands its variant id
 * to the cart drawer's existing [data-cd-quick-add] handler — so the theme keeps
 * one add path rather than growing a second one here.
 *
 * Delegated, because the grid can be re-rendered by the section API.
 */
(function () {
  function closeAll(except) {
    var open = document.querySelectorAll('[data-vng-quick][data-open]');
    for (var i = 0; i < open.length; i++) {
      if (open[i] === except) continue;
      open[i].removeAttribute('data-open');
      var sizes = open[i].querySelector('[data-vng-sizes]');
      var btn = open[i].querySelector('[data-vng-open]');
      if (sizes) sizes.hidden = true;
      if (btn) btn.setAttribute('aria-expanded', 'false');
    }
  }

  document.addEventListener('click', function (event) {
    var target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    var opener = target.closest('[data-vng-open]');
    if (opener) {
      var quick = opener.closest('[data-vng-quick]');
      var sizes = quick.querySelector('[data-vng-sizes]');
      var isOpen = quick.hasAttribute('data-open');
      closeAll(quick);
      if (isOpen) {
        quick.removeAttribute('data-open');
        sizes.hidden = true;
        opener.setAttribute('aria-expanded', 'false');
      } else {
        quick.setAttribute('data-open', '');
        sizes.hidden = false;
        opener.setAttribute('aria-expanded', 'true');
        var first = sizes.querySelector('button:not([disabled])');
        if (first) first.focus();
      }
      return;
    }

    /* A size was chosen. The drawer's handler does the add; this only tidies up
       after it, so the card is not left showing an open size list. */
    var size = target.closest('[data-cd-quick-add]');
    if (size && size.closest('[data-vng-quick]')) {
      closeAll(null);
      return;
    }

    /* Anywhere else closes an open card. */
    if (!target.closest('[data-vng-quick]')) closeAll(null);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAll(null);
  });
})();

/**
 * "Show all colours" on the grid.
 *
 * Every card is rendered; the extra ones simply carry `hidden`. Revealing them
 * costs no request, and search engines see all twelve either way.
 */
(function () {
  var button = document.querySelector('[data-vng-more]');
  if (!button) return;

  button.addEventListener('click', function () {
    var extra = document.querySelectorAll('.vng__item--more');
    var opening = button.getAttribute('aria-expanded') !== 'true';

    for (var i = 0; i < extra.length; i++) extra[i].hidden = !opening;
    button.setAttribute('aria-expanded', opening ? 'true' : 'false');
    button.textContent = opening
      ? button.getAttribute('data-vng-less-label')
      : button.getAttribute('data-vng-more-label');

    /* Collapsing from below the fold would leave the shopper staring at the
       footer, so bring the button back into view. */
    if (!opening) button.scrollIntoView({ block: 'center', behavior: 'smooth' });
  });
})();
